<template>
  <tr class="text-body text-black-2 h-9">
    <td class="w-96 p-2! text-left">Name</td>
    <td class="w-32 p-2! text-right">Users</td>
    <td v-if="!hideImpressions" class="w-32 p-2! text-right">Impr.</td>
    <td class="w-32 p-2! text-right">Clicks</td>
    <td class="w-32 p-2! text-right">{{ convRateOverCtr ? "Conv.Rate" : "CTR" }}</td>
  </tr>
</template>

<script setup>
defineProps({
  hideImpressions: { type: Boolean, default: false },
  convRateOverCtr: { type: Boolean, default: false },
});
</script>
